import * as Yup from "yup";

export const wodVoiceSchema = Yup.object().shape({
  name: Yup.string()
    .max(100, "cannot be > 100 characters")
    .required("Workout name is required"),
  type: Yup.string().required("Workout Type is required"),
  duration: Yup.string().required("Workout Duration is required"),
  instructions: Yup.array().required("Instruction is required"),
});
